import { useGlobalContext } from "../Layout/GlobalState";
import axios from "../api/AxiosConfig";

export const CREDENTIALS_STORAGE_NAME = "screenType";

export const useSigninService = () => {
  const globalContext = useGlobalContext();

  const signin = async (username?: string, password?: string) => {
    if (username && password) {
      const encodedCredentials = btoa(`${username}:${password}`);
      sessionStorage.setItem(CREDENTIALS_STORAGE_NAME, encodedCredentials);
    }

    try {
      const response = await axios.get("/api/login", {
        headers: {
          Authorization:
            username == null || password == null
              ? undefined
              : `Basic ${btoa(`${username}:${password}`)}`,
        },
        responseType: "text",
      });

      const autorized = 200 <= response.status && response.status < 300;
      const role = autorized ? response.data : undefined;
      globalContext.setAuthorizedAs(role);

      return autorized;
    } catch (e) {
      // Non 2xx response, do nothing
    }
    return false;
  };

  const signout = async () => {
    axios.get("/api/logout", { responseType: "text" });
    sessionStorage.clear();
    globalContext.setAuthorizedAs(undefined);
    return true;
  };

  const checkSigninStatus = async () => {
    return signin();
  };

  return { checkSigninStatus, signin, signout };
};
